import { lazy } from 'react';

type ImportFunction = () => Promise<any>;
const MAX_RETRIES = 4;
const RETRY_INTERVAL = 250;

const importRetryWrapper = (
  importFunction: ImportFunction,
  retries: number = MAX_RETRIES,
  interval: number = RETRY_INTERVAL,
): Promise<any> =>
  new Promise((resolve, reject) => {
    importFunction()
      .then(resolve)
      .catch((error) => {
        if (retries === 0) {
          reject(error);
        } else {
          setTimeout(
            () =>
              // eslint-disable-next-line promise/no-nesting
              importRetryWrapper(importFunction, retries - 1, interval * retries).then(
                resolve,
                reject,
              ),
            interval,
          );
        }
      });
  });

const lazyWithRetry = (importFunction: ImportFunction) =>
  lazy(() => importRetryWrapper(importFunction));

export { importRetryWrapper, lazyWithRetry };
